<div class="mlp-outer" [class.mlp-loading-active]="isLoading()">

  <!-- Loading overlay -->
  @if (isLoading()) {
    <div class="mlp-loading-overlay">
      <span class="lm-grid-loading">
        <span class="lm-grid-spinner"></span>{{ 'leave_management.manager_leave_panel.fetching_records_hellip' | transloco }}
      </span>
    </div>
  }

  <!-- ── Top heading row ──────────────────────────────────────────────────── -->
  <div class="mlp-top-row">

    <!-- Left title + controls -->
    <div class="mlp-top-left">
      <span class="mlp-card-title">{{ onLeaveTitle() }}</span>
      <button class="mlp-today-btn" (click)="resetToToday()">{{ 'leave_management.manager_leave_panel.today' | transloco }}</button>
      <div class="mlp-date-box">
        <input
          type="date"
          class="mlp-date-input"
          [(ngModel)]="selectedDate"
          (ngModelChange)="onDateChange()"
        />
        <span class="mlp-date-text">
          <span class="material-icons mlp-cal-icon">{{ 'leave_management.manager_leave_panel.calendar_today' | transloco }}</span>
          {{ selectedDateDisplay }}
        </span>
      </div>
    </div>

    <!-- Right title -->
    <div class="mlp-top-right">
      <span class="mlp-card-title">{{ upcomingTitle() }}</span>
    </div>

  </div>

  <!-- ── Two inner boxes ──────────────────────────────────────────────────── -->
  <div class="mlp-inner-grid">

    <!-- Left inner box -->
    <div class="mlp-inner-box">
      <table class="mlp-table">
        <thead>
          <tr>
            <th>{{ 'leave_management.manager_leave_panel.employee_name' | transloco }}</th>
            <th>{{ 'leave_management.manager_leave_panel.total_days' | transloco }}</th>
            <th>{{ 'leave_management.manager_leave_panel.leave_type' | transloco }}</th>
          </tr>
        </thead>
        <tbody>
          @for (row of onLeaveRows; track $index) {
            <tr>
              <td>
                <div class="mlp-emp-cell">
                  <div class="mlp-avatar" [style.background]="row.avatarColor">{{ row.initials }}</div>
                  <span class="mlp-emp-name">{{ row.employeeName }}</span>
                </div>
              </td>
              <td class="mlp-date-cell">
                @if (!isHourlyMode()) {
                  @for (line of row.dateLines; track $index) {
                    <div>{{ line }}</div>
                  }
                  @if (row.isHalfDay) {
                    <span class="mlp-half-day-pill">{{ row.halfDayTime }}</span>
                  }
                }
                @if (isHourlyMode()) {
                  @for (line of row.dateLines; track $index) {
                    <div>{{ line }}</div>
                  }
                  <span class="mlp-time-range">{{ row.timeRange }}</span>
                }
              </td>
              <td>
                <span class="mlp-badge" [style.background]="row.style.bg" [style.color]="row.style.text">
                  @if (row.style.dot) {
                    <span class="mlp-dot" [style.background]="row.style.dot"></span>
                  }
                  {{ row.leaveType }}
                </span>
              </td>
            </tr>
          }
          @if (onLeaveRows.length === 0) {
            <tr>
              <td colspan="3" class="mlp-empty">{{ 'leave_management.manager_leave_panel.no_employees_on_leave_for_this_date' | transloco }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    <!-- Right inner box -->
    <div class="mlp-inner-box">
      <table class="mlp-table">
        <thead>
          <tr>
            <th>{{ 'leave_management.manager_leave_panel.employee_name' | transloco }}</th>
            <th>{{ 'leave_management.manager_leave_panel.total_days' | transloco }}</th>
            <th>{{ 'leave_management.manager_leave_panel.leave_type' | transloco }}</th>
          </tr>
        </thead>
        <tbody>
          @for (row of upcomingRows; track $index) {
            <tr>
              <td>
                <div class="mlp-emp-cell">
                  <div class="mlp-avatar" [style.background]="row.avatarColor">{{ row.initials }}</div>
                  <span class="mlp-emp-name">{{ row.employeeName }}</span>
                </div>
              </td>
              <td class="mlp-date-cell">
                @if (!isHourlyMode()) {
                  @for (line of row.dateLines; track $index) {
                    <div>{{ line }}</div>
                  }
                  @if (row.isHalfDay) {
                    <span class="mlp-half-day-pill">{{ row.halfDayTime }}</span>
                  }
                }
                @if (isHourlyMode()) {
                  @for (line of row.dateLines; track $index) {
                    <div>{{ line }}</div>
                  }
                  <span class="mlp-time-range">{{ row.timeRange }}</span>
                }
              </td>
              <td>
                <span class="mlp-badge" [style.background]="row.style.bg" [style.color]="row.style.text">
                  @if (row.style.dot) {
                    <span class="mlp-dot" [style.background]="row.style.dot"></span>
                  }
                  {{ row.leaveType }}
                </span>
              </td>
            </tr>
          }
          @if (upcomingRows.length === 0) {
            <tr>
              <td colspan="3" class="mlp-empty">{{ 'leave_management.manager_leave_panel.no_upcoming_employee_leaves' | transloco }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>

  </div>
</div>
